import loadable from '@loadable/component';
import React from 'react';
import { useWindowSize } from 'react-use';
import { CollectionMembershipViewProps } from './types';

const CollectionMembershipDropdown = loadable(
    () =>
        import(
            /* webpackChunkName: "CollectionDropdown" */ './CollectionMembershipDropdown'
        ),
);
const CollectionMembershipModal = loadable(
    () =>
        import(
            /* webpackChunkName: "CollectionModal" */ './CollectionMembershipModal'
        ),
);

export const CollectionMembershipView: React.FunctionComponent<
    CollectionMembershipViewProps
> = (props) => {
    const { width } = useWindowSize();

    const Component =
        width > 670 ? CollectionMembershipDropdown : CollectionMembershipModal;

    return <Component {...props} />;
};
